import fetchData from "../API/Fetch";
import { store } from "../store";

export default async function fetchDeviceBrands() {
  let result = await fetchData(`/device-brands/`);

  store.dispatch({
    type: "deviceBrands/update",
    payload: result ? result : [],
  });
  return result;
}
